import { firstValueFrom } from 'rxjs';

import { MpsUser } from '../../app/models/mps-user.model';
import { MpsUserService } from '../services/mps-user.service';

export function mpsFetchUser(userService: MpsUserService) {
  return async (): Promise<MpsUser | undefined> => {
    try {
      if (!window.location.href.includes('oauth2/token') && !window.location.href.includes('login?error=')) {
        const userPromise = firstValueFrom(userService.fetchUser());
        return await userPromise;
      }

      return undefined;
    } catch (_error) {
      return undefined;
    }
  };
}
